
import { defineComponent } from "vue";
import { Optional } from "@/globalTypes";
import { mapActions } from "vuex";
import Loading from "@/components/Loading.vue";

interface ForgotPasswordViewData {
  email: string;
  emailError: Optional<string>;
  isEmailSend: boolean;
  globalError: string;
  isSending: boolean;
}

export default defineComponent({
  data(): ForgotPasswordViewData {
    return {
      email: "",
      emailError: null,
      isEmailSend: false,
      globalError: "",
      isSending: false,
    };
  },
  methods: {
    ...mapActions("accounts", ["requestResetPassword"]),
    handleResetPassword() {
      this.isSending = true;
      this.requestResetPassword(this.email || "").then(({ success, error }) => {
        this.isSending = false;
        if (success) {
          this.isEmailSend = true;
        } else {
          this.emailError = error.email;
          this.globalError = error.message;
        }
      });
    },
  },
  components: { Loading },
  hideCarHeader: true,
});
